import { hasTargetingConsent } from '../consent';
import type { CartSnapshotProperties, LegacyAddedItemProperties } from './cartSnapshot';
import { SegmentProduct } from './events';

type CIO = {
  track: (event: string, properties?: Record<string, unknown>) => void;
};

export class CustomerIO {
  private static getCio(): CIO | undefined {
    return (window as any)._cio as CIO | undefined;
  }

  private static EVENTS = {
    ADDED_ITEM_TO_CART: 'Added Item To Cart',
    SHIPPING_PAGE_CONTINUE: 'Shipping page > Continue',
    STARTED_CHECKOUT: 'Started Checkout',
  };

  static trackShippingPageContinue(products: SegmentProduct[]): void {
    this.getCio()?.track(CustomerIO.EVENTS.SHIPPING_PAGE_CONTINUE, { products });
  }

  /** Starts the cart-abandonment campaign; see `useTrackAddedItemToCart` for how the snapshot is built. */
  static trackAddedItemToCart(snapshot: CartSnapshotProperties | LegacyAddedItemProperties): void {
    // Sent after the bag prices the cart, possibly on a later page, so consent is checked at send time.
    if (!hasTargetingConsent()) {
      return;
    }
    this.getCio()?.track(CustomerIO.EVENTS.ADDED_ITEM_TO_CART, { ...snapshot });
  }

  static trackStartedCheckout(products: SegmentProduct[]) {
    this.getCio()?.track(CustomerIO.EVENTS.STARTED_CHECKOUT, { products });
  }
}
